import React, { useState, useEffect,useMemo } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';

import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import RootRef from '@material-ui/core/RootRef';


const createClasses = (obj, property, name_addition = '') => (
  Object.keys(obj).reduce((a, c) =>({...a, [`${name_addition}_${c}`]: { [property]: obj[c]} }),{})
);


const create_classes_with_func = (obj, func, theme, name_addition = 'arrow_popper') => (
  Object.keys(obj).reduce((a, c) => ({
    ...a,
    [`${name_addition}_${c}`]: { ...func(theme, obj[c]) }
  }),{})
);

function arrowGenerator(color) {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.95em',
      width: '3em',
      height: '1em',
      //left: '50%',
      //transform:'translateX(-50%)',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent ${color} transparent`,
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.95em',
      width: '3em',
      height: '1em',
    //  left: '50%',
      //transform:'translateX(-50%)',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: `${color} transparent transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
        left: 0,
        marginLeft: '-0.95em',
        height: '2em',
        width: '1em',
        '&::before': {
          borderWidth: '1em 1em 1em 0',
          borderColor: `transparent ${color} transparent transparent`,
        },

    },
    '&[x-placement*="left"] $arrow': {
          right: 0,
          marginRight: '-0.95em',
          height: '2em',
          width: '1em',
          '&::before': {
            borderWidth: '1em 0 1em 1em',
            borderColor: `transparent transparent transparent ${color}`,
          },
    }
  };
}

const styles = theme => ({
  arrow: {
    position: 'absolute',
    fontSize: 7,
    width: '3em',
    height: '3em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
  popper: arrowGenerator(theme.palette.grey[700]),
  tooltipPlacementLeft: {
    margin: '0 8px',
  },
  tooltipPlacementRight: {
    margin: '0 8px',
  },
  tooltipPlacementTop: {
    margin: '8px 0',
  },
  tooltipPlacementBottom: {
    margin: '8px 0',
  },
  tooltip: {
    fontSize: 12,
    background: theme.palette.grey[700],
    padding: '8px 10px',
    position: 'relative',
  },
  children_class: {
    display:'inline-block'
  }
});

const is_arr_included = (arr, values) => {
  for (let v of arr) {
    if (arr.includes(v)) { continue; }
    else { return false }
  }
  return true;
}

const ArrowTooltip = withStyles(styles)((
  {
    classes: {
       tooltip,
       popper,
       arrow,
       tooltipPlacementTop,
       tooltipPlacementBottom,
       tooltipPlacementLeft,
       tooltipPlacementRight,
       children_class,
       ...other
     },
     width,
     children,
     show_tooltip,
     ref,
     tooltip_text,
     placement: tooltip_placement,
     ...other_props
  }
) => {
  const [arrowRef, set_arrow_ref] = React.useState(null);

  const [s_placement, set] = useState(null);
  let timeout = false, timer;

  const placement = useMemo(() => {
    if (!arrowRef) { return tooltip_placement; }
    if (["top","bottom"].includes(tooltip_placement) || (["md","xl","lg"].includes(width))) { return tooltip_placement; }
    const ref_width = arrowRef.scrollWidth;
    const approximate_message_width = tooltip_text.length < 45 ? Math.round(tooltip_text.length * 10) : 320;
    if (((window.innerWidth / 2) - (ref_width / 2)) < approximate_message_width) {
      return "bottom";
    }
    return tooltip_placement;
  },[width, tooltip_placement, tooltip_text, arrowRef]);


  return (
    <Tooltip
        open = { show_tooltip || undefined }
        placement = { placement }
        disableFocusListener
        title= {
          <>
            { tooltip_text }
            <span className={ arrow } ref={set_arrow_ref} />
          </>
        }
        classes={{
          tooltip,
          popper,
          tooltipPlacementTop,
          tooltipPlacementBottom,
          tooltipPlacementLeft,
          tooltipPlacementRight,
        }}
        PopperProps={{
          popperOptions: {
            modifiers: {
              arrow: {
                enabled: Boolean(arrowRef),
                element: arrowRef
              },
            },
          },
        }}
      >
      <div className = {children_class}>
      { children }
      </div>
    </Tooltip>
  )
})

/*

*/

ArrowTooltip.propTypes = {
  classes: PropTypes.shape({
    tooltip: PropTypes.string.isRequired,
    tooltipPlacementLeft: PropTypes.string.isRequired,
    tooltipPlacementRight: PropTypes.string.isRequired,
    tooltipPlacementTop: PropTypes.string.isRequired,
    tooltipPlacementBottom: PropTypes.string.isRequired
  }).isRequired,
  tooltip_text: PropTypes.string.isRequired,
  placement: PropTypes.oneOf(["top","left","bottom","right"]).isRequired,
  show_tooltip: PropTypes.bool
}

ArrowTooltip.defaultProps = {
  placement: "left",
}

export default withWidth()(withStyles(styles)(ArrowTooltip));
